import { useDroppable } from "@dnd-kit/core";
import { Paper } from "@mui/material";
import { FC, PropsWithChildren, forwardRef } from "react";

interface GameDropProps extends PropsWithChildren {
  id: string;
  want: string[];
}

export const GameDroppable: FC<GameDropProps> = ({ children, id, want }) => {
  const { setNodeRef } = useDroppable({
    id: id,
    data: {
      want: want,
    },
  });
  return (
    <Paper variant="droppable" ref={setNodeRef} elevation={0}>
      {children}
    </Paper>
  );
};
